import React from 'react';
import { WandIcon, UsersIcon, ZapIcon, PaletteIcon, GamepadIcon, ShareIcon } from 'lucide-react';
export function Features() {
  const features = [{
    icon: ZapIcon,
    title: 'No Coding Required',
    description: 'Create games without writing a single line of code using our AI'
  }, {
    icon: WandIcon,
    title: 'Remix Anything',
    description: 'Transform any game into your own unique creation in minutes'
  }, {
    icon: PaletteIcon,
    title: 'Customize Everything',
    description: 'Change themes, rules, and visuals to match your vision'
  }, {
    icon: UsersIcon,
    title: 'Community Driven',
    description: 'Join our community of creators sharing new games every day'
  }, {
    icon: GamepadIcon,
    title: 'Instantly Playable',
    description: 'Test and play your creations immediately as you build'
  }, {
    icon: ShareIcon,
    title: 'Share & Publish',
    description: 'Publish your games and share them with the world in one click'
  }];
  return <section className="w-full px-4 py-20 bg-white" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-24">
            Everything You Need to Create
          </h2>
          <p className="text-xl text-gray-600" data-id="element-25">
            Powerful tools designed for creators of all skill levels
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-26">
          {features.map((feature, index) => <div key={index} className="p-6 rounded-2xl border-2" style={{
          borderColor: '#F5EBE0'
        }} data-id="element-27">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
            background: 'linear-gradient(135deg, #F5EBE0 0%, #e8d5c3 50%, #D4AF71 100%)'
          }} data-id="element-28">
                <feature.icon className="w-6 h-6" style={{
              color: '#31192E'
            }} data-id="element-29" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-30">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-31">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}